import React from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import DatePickerDropdownList from '../DatePickerDropdownList';
import { fixZero } from '../tools/date';
import { getValue } from '../tools/util';
import { getTimeFormat } from '../tools/timePanels';

var generateSequence = function generateSequence(number, step) {
  var start = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  if (typeof step !== 'number' || step === 0) {
    step = 1;
  }

  return Array(Math.ceil(number / step)).fill(null).map(function (_v, i) {
    return fixZero(i * step + start);
  });
};

var customEqual = function customEqual(value, idx, selectValue) {
  if (!value) return false;
  return Number(value.split(':')[idx]) === Number(selectValue);
};

export var defaultCustomReplace = function defaultCustomReplace() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var idx = arguments.length > 1 ? arguments[1] : undefined;
  var newValue = arguments.length > 2 ? arguments[2] : undefined;
  var valueArr = value.split(':');
  valueArr[idx] = newValue;
  return valueArr.join(':');
};
export var DefaultCustomReplace = function DefaultCustomReplace(config) {
  return function (value, idx, newValue) {
    var _value;

    value = (_value = value) !== null && _value !== void 0 ? _value : getTimeFormat(config);
    var valueArr = value.split(':');
    valueArr[idx] = newValue;
    return valueArr.join(':');
  };
};

var TimePickerPanel = function TimePickerPanel(_ref) {
  var _getValue;

  var className = _ref.className,
      title = _ref.title,
      value = _ref.value,
      panelEcho = _ref.panelEcho,
      sequence = _ref.sequence,
      showHour = _ref.showHour,
      showMinute = _ref.showMinute,
      showSecond = _ref.showSecond,
      isHourDisabled = _ref.isHourDisabled,
      isMinuteDisabled = _ref.isMinuteDisabled,
      isSecondDisabled = _ref.isSecondDisabled,
      hourStep = _ref.hourStep,
      minuteStep = _ref.minuteStep,
      secondStep = _ref.secondStep,
      minuteStart = _ref.minuteStart,
      hourStart = _ref.hourStart,
      secondStart = _ref.secondStart,
      update = _ref.update,
      isValueDisabled = _ref.isValueDisabled,
      customReplace = _ref.customReplace;
  customReplace = DefaultCustomReplace({
    showMinute: showMinute,
    showHour: showHour,
    showSecond: showSecond
  });
  var panelData = [].concat(sequence ? getValue(sequence).map(function (s) {
    s = getValue(s);
    return {
      listData: s.list,
      isTimeDisabled: s.isItemDisabled || function () {
        return false;
      }
    };
  }) : []);

  if (showHour) {
    panelData.push({
      listData: generateSequence(24, hourStep, hourStart),
      isTimeDisabled: isHourDisabled
    });
  }

  if (showMinute) {
    panelData.push({
      listData: generateSequence(60, minuteStep, minuteStart),
      isTimeDisabled: isSecondDisabled
    });
  }

  if (showSecond) {
    panelData.push({
      listData: generateSequence(60, secondStep, secondStart),
      isTimeDisabled: isMinuteDisabled
    });
  }

  return /*#__PURE__*/React.createElement(DatePickerDropdownList, {
    className: classNames('jmtd-time-picker-panel', className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "jmtd-time-picker-header"
  }, title && /*#__PURE__*/React.createElement("span", {
    className: "jmtd-time-picker-header-title"
  }, title), /*#__PURE__*/React.createElement("span", {
    className: "jmtd-time-picker-header-value"
  }, (_getValue = getValue(panelEcho, value)) !== null && _getValue !== void 0 ? _getValue : "\xA0")), /*#__PURE__*/React.createElement("div", {
    className: "jmtd-time-picker-body"
  }, panelData.map(function (_ref2, idx) {
    var listData = _ref2.listData,
        isTimeDisabled = _ref2.isTimeDisabled;
    return /*#__PURE__*/React.createElement("ul", {
      key: idx,
      className: "jmtd-time-picker-container"
    }, listData.map(function (text) {
      var disabled = isTimeDisabled(text) || isValueDisabled(customReplace(value, idx, text));
      return /*#__PURE__*/React.createElement("li", {
        key: text,
        className: classNames({
          'jmtd-time-picker-item': true,
          'jmtd-time-picker-item-selected': customEqual(value, idx, text),
          'jmtd-time-picker-item-disabled': disabled
        }),
        onClick: function onClick() {
          if (disabled) return;
          update(idx, text);
        }
      }, text);
    }));
  })));
};

TimePickerPanel.propTypes = {
  className: PropTypes.string,
  title: PropTypes.node,
  value: PropTypes.string,
  showHour: PropTypes.bool,
  showMinute: PropTypes.bool,
  showSecond: PropTypes.bool,
  isHourDisabled: PropTypes.func,
  isMinuteDisabled: PropTypes.func,
  isSecondDisabled: PropTypes.func,
  hourStep: PropTypes.number,
  minuteStep: PropTypes.number,
  secondStep: PropTypes.number,
  hourStart: PropTypes.number,
  minuteStart: PropTypes.number,
  secondStart: PropTypes.number,
  update: PropTypes.func,
  isValueDisabled: PropTypes.func,
  customReplace: PropTypes.func,
  panelEcho: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  sequence: PropTypes.array
};
TimePickerPanel.defaultProps = {
  className: '',
  title: null,
  value: null,
  showHour: false,
  showMinute: false,
  showSecond: false,
  isHourDisabled: function isHourDisabled() {
    return false;
  },
  isMinuteDisabled: function isMinuteDisabled() {
    return false;
  },
  isSecondDisabled: function isSecondDisabled() {
    return false;
  },
  hourStep: 1,
  minuteStep: 1,
  secondStep: 1,
  hourStart: 0,
  minuteStart: 0,
  secondStart: 0,
  update: function update() {},
  isValueDisabled: function isValueDisabled() {
    return false;
  },
  customReplace: undefined,
  panelEcho: function panelEcho(x) {
    return x;
  },
  sequence: undefined
};
export default TimePickerPanel;